import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  background: var(--background);
  color: var(--text);
  overflow: auto;
`;
